
const showMetafields = (event) => {
    event.preventDefault();
    // Selectors 
    const contaner =  event.target.closest('.product-metafields-container');
    const parent = event.target.closest(".product-metafields");
    const content_parent = document.querySelector(".product--metafields-content");
    const block_id = parent.querySelector(".detils--container").dataset.id;
    const active_metafield = document.querySelector('.active-metafield');
    const active_content = document.querySelector('.is-active-content');
    const content_to_show = content_parent.querySelector(`[data-id="${block_id}"]`);

    // Add/Remove class
    active_metafield.classList.remove('active-metafield');
    parent.classList.add('active-metafield');
    active_content.classList.remove('is-active-content');
    content_to_show.classList.add('is-active-content');

    contaner.scrollLeft = parent.offsetLeft - contaner.offsetLeft;
}

const openQuestion = (event) => {
    event.preventDefault();

    const parent = event.target.closest(".question");
    const active_question = document.querySelector('.active-question');
    if (active_question && active_question !== parent.querySelector('.question--content')) {
        active_question.classList.remove('active-question');
    }
    parent.querySelector('.question--content').classList.toggle('active-question');

}


const openAccordion = (event) => {
  event.preventDefault();
  const parent = event.target.closest(".product-metafields ");

  const active_accordion = document.querySelector('.active_content_test');
  if (active_accordion && active_accordion !== parent) {
      active_accordion.classList.remove('active_content_test');
  }
  parent.classList.toggle('active_content_test');

  if (parent.classList.contains('active_content_test')) {
      parent.focus();
      const previousElement = parent.previousElementSibling;
      const secondPreviousElement = previousElement.previousElementSibling ? previousElement.previousElementSibling : previousElement ? previousElement :  parent;
      secondPreviousElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
